import { render, staticRenderFns } from "./Area3.vue?vue&type=template&id=53854e3a&scoped=true&"
import script from "./Area3.vue?vue&type=script&lang=js&"
export * from "./Area3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53854e3a",
  null
  
)

export default component.exports